import { useMemo } from 'react';
import { PeriodoModo, StatusFilterValue } from './constants';
import { buildIntegrationErrorsRequestParams } from './utils';

interface UseIntegrationErrorsRequestParamsInput {
  textInput: string;
  statusFilter: StatusFilterValue;
  periodoAplicado: {
    modo: PeriodoModo;
    range: Date[];
  };
}

const useIntegrationErrorsRequestParams = ({
  textInput,
  statusFilter,
  periodoAplicado,
}: UseIntegrationErrorsRequestParamsInput) =>
  useMemo(
    () =>
      buildIntegrationErrorsRequestParams({
        textInput,
        statusFilter,
        periodoAplicado,
      }),
    [textInput, statusFilter, periodoAplicado],
  );

export default useIntegrationErrorsRequestParams;
